// @docs https://[domain]/api/v1/docs
export default {
  List: "/tenants",
  Detail: "/tenants",
  Update: "/tenants",
  Create: "/tenants",
  ListShort: "/tenants/short",
};
